class Nav
{
    constructor()
    {
        this.match = gsap.matchMedia();
        this.init();
    }

    init()
	{
		
		if (window.innerWidth >= 1025) {
			document.querySelectorAll('.menu-item-has-children').forEach(item => {
				
				const siteHeader = document.querySelector('.site-header');
				const rowHeader = document.querySelector('.row-header');
				const subMenu = item.querySelector('.sub-menu');
				const subMenuItems = subMenu ? subMenu.querySelectorAll('li') : [];
				let isMenuActive = false; 

				// Fonction pour activer la classe et afficher le sous-menu
				const activateMenu = () => {

					if (isMenuActive) return; // Si déjà activé, ne rien faire
					isMenuActive = true;

				siteHeader.classList.add('extend-sub-menu');
				rowHeader.classList.add('extend-sub-menu');
			
				if (subMenu) {
					// Afficher le sous-menu
					gsap.to(subMenu, {
					opacity: 1,
					y: 0,
					visibility: 'visible',
					display:"block",
					duration: 0.3,
					ease: 'power1.out',
					});
			
					// Afficher graduellement les items du sous-menu
					gsap.fromTo(
					subMenuItems,
					{ opacity: 0, y: -20 },
					{ opacity: 1, y: 0, stagger: 0.1, duration: 0.5, ease: 'power1.out' }
					);
				}
				};
			
				// Fonction pour désactiver la classe et masquer le sous-menu
				const deactivateMenu = () => {

					isMenuActive = false; // Réinitialiser

				siteHeader.classList.remove('extend-sub-menu');
				rowHeader.classList.remove('extend-sub-menu');
			
				if (subMenu) {
					// Masquer le sous-menu
					gsap.to(subMenu, {
					opacity: 0,
					y: -10,
					visibility: 'hidden',
					display:"none",
					duration: 0.3,
					ease: 'power1.in',
					});
			
					// Réinitialiser les items du sous-menu
					gsap.to(subMenuItems, {
					opacity: 0,
					y: 10,
					stagger: 0,
					duration: 0,
					});
				}
				};
			
				// Activer le menu lorsque la souris entre dans le parent ou le sous-menu
				item.addEventListener('mouseenter', activateMenu);
				item.addEventListener('mouseleave', event => {
					if (!subMenu.contains(event.relatedTarget)) {
						deactivateMenu();
					}
				});
			
				if (subMenu) {
					subMenu.addEventListener('mouseenter', activateMenu);
					subMenu.addEventListener('mouseleave', event => {
						if (!item.contains(event.relatedTarget)) {
						deactivateMenu();
						}
					});
				}
			});
		}




			const toggle = document.getElementById('menu-toggle');
			const header = document.querySelector('.site-header');

			toggle.addEventListener('change', function () {
				if (this.checked) {
					header.classList.add('open');
				} else {
					header.classList.remove('open');
				}
			});

			// Auto-reset on window resize (1025px+)
			window.addEventListener('resize', function () {
				if (window.innerWidth > 1025) {
					header.classList.remove('open');
					toggle.checked = false;
				}
			});
	}

}

export default Nav;